
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import type { ScheduledCoupon } from "@/types/scheduled-coupons";
import { useActiveStoreId } from "../useActiveStoreId";

export const useScheduledCoupons = (campaignId?: string) => {
  const { data: storeId } = useActiveStoreId();
  return useQuery({
    queryKey: ["scheduled-coupons", campaignId, storeId],
    queryFn: async (): Promise<ScheduledCoupon[]> => {
      // Filtro obrigatório: só mostrar cupons da loja ativa
      if (!storeId) {
        console.log('No active store found, returning empty coupons list');
        return [];
      }

      let query = supabase
        .from('campaign_generated_coupons')
        .select(`
          *,
          campaigns(
            id,
            name,
            type,
            start_date,
            end_date,
            minimum_spent_amount
          ),
          cashback_templates(
            id,
            name,
            percentage,
            multiplier,
            expiration_days
          )
        `)
        .eq('store_id', storeId) // Filtro obrigatório por store_id
        .order('created_at', { ascending: false });

      if (campaignId) {
        query = query.eq('campaign_id', campaignId);
      }

      const { data, error } = await query;

      if (error) throw error;
      return (data as any[]) || [];
    },
    enabled: !!storeId,
  });
};
